import React, {Component} from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import {round} from "lodash"

import {injectIntl} from "@irati/utils/lang"
import {greys} from "@irati/ui/src/global/colors"
import {Label3} from "@irati/ui/src/Labels"
import padding from "@irati/ui/src/global/padding"
import HasPermissionTo from "@irati/utils/permissions/HasPermissionTo"

import UpArrow from "../../../images/icons/upArrow.svg"
import DownArrow from "../../../images/icons/downArrow.svg"
import {Tooltip} from "../../ui/Tooltip"

import {CHANGE_OVER_TIME_POSITIVE_COLOR, CHANGE_OVER_TIME_NEGATIVE_COLOR, DEMO_DATA_BACKGROUND_COLOR} from "../../ui/colors.js"
import {COT_TOOLTIP_CONTEXT_DEFAULT} from "../../utils/constants/changeOverTime"

const StyledLabel = styled(Label3)`
  background-color: ${({color}) => color};
  padding: 3px 7px;
  border-radius: ${padding.tiny};
  white-space: nowrap;
  color: ${({fontColor}) => fontColor};
  display: flex;
  justify-content: center;
  min-width: 40px;
  cursor: pointer;
`

const ImageContainer = styled.img`
  margin-right: 5px;
  `
const ChangeOverTimeWrapper = styled.div`
  display: flex;
`

const MIN_CHANGE = 1
class ChangeOverTime extends Component {
  static propTypes = {
    className: PropTypes.string,
    currentScore: PropTypes.number.isRequired,
    historicalScore: PropTypes.number
  }
  static defaultProps = {
    className: null
  }

  calculateChangeOverTime = () => {
    const {currentScore, historicalScore} = this.props
    if (historicalScore) {
      const difference = historicalScore - currentScore
      const changeOverTime = (difference / historicalScore) * 100
      return this.getColorIconAndText(changeOverTime)
    }
    return this.handleNoHistoricalData()
  }

  getColorIconAndText = (changeOverTime) => {
    const changeOverTimeScore = round(changeOverTime, 1)
    if (changeOverTime >= MIN_CHANGE) {
      return {
        score: changeOverTimeScore.toFixed(1),
        icon: UpArrow,
        color: CHANGE_OVER_TIME_POSITIVE_COLOR,
        fontColor: greys.white,
        toolTipContentId: "insights.changeOverTime.positive.toolTipText"
      }
    }
    if (changeOverTime <= -MIN_CHANGE) {
      return {
        score: Math.abs(changeOverTimeScore).toFixed(1),
        icon: DownArrow,
        color: CHANGE_OVER_TIME_NEGATIVE_COLOR,
        fontColor: greys.white,
        toolTipContentId: "insights.changeOverTime.negative.toolTipText"
      }
    }
    return {
      score: 0,
      color: DEMO_DATA_BACKGROUND_COLOR,
      fontColor: greys.black,
      toolTipContentId: "insights.changeOverTime.noDifference.toolTipText"
    }
  }

  handleNoHistoricalData = () => {
    return {
      score: "-",
      color: DEMO_DATA_BACKGROUND_COLOR,
      fontColor: greys.black,
      toolTipContentId: "insights.changeOverTime.noData.toolTipText"
    }
  }

  render() {
    const {className, formatMessage, contextContentId, hideTooltip} = this.props
    const overlayComponent = hideTooltip ? () => <span /> : null

    const context = formatMessage({id: contextContentId})

    const changeOverTime = this.calculateChangeOverTime()
    const {score, color, fontColor, toolTipContentId, icon} = changeOverTime
    return (
      <HasPermissionTo permissions={["insights.changeOverTime"]} Error={null}>
        <Tooltip tooltipChildren={formatMessage({id: toolTipContentId}, {context})} OverlayComponent={overlayComponent}>
          <StyledLabel className={className} bold uppercase color={color} fontColor={fontColor}>
            <ChangeOverTimeWrapper>
              {icon && <ImageContainer src={icon} alt="" size={20} />}
              {score} {score > 0 && "%"}
            </ChangeOverTimeWrapper>
          </StyledLabel>
        </Tooltip>
      </HasPermissionTo>

    )
  }
}

ChangeOverTime.propTypes = {
  contextContentId: PropTypes.string,
  formatMessage: PropTypes.func.isRequired,
  hideTooltip: PropTypes.bool
}

ChangeOverTime.defaultProps = {
  contextContentId: COT_TOOLTIP_CONTEXT_DEFAULT,
  hideTooltip: false
}

export default injectIntl(ChangeOverTime)
